export default "__VITE_PUBLIC_ASSET__782d0a45__"